import ResearchAssignments from './ResearchAssignments';

export default ResearchAssignments;
